import AudioPlayer from 'react-h5-audio-player'
import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Transcript from '../Transcript'
import Icon from '../Icon'
import Picture from '../Picture'

export const Container = styled.div<{ $color?: string }>`
  // variables
  --color__player: ${({ $color }) => $color};
  --height__progress: ${pxToRem(12)};
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
  }
`
// custom player
export const Wrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.5);
`
export const Content = styled.div`
  @media ${mq(sizes.tablet)} {
    display: flex;
  }
`
export const _Picture = styled(Picture)`
  flex-flow: 0 0 auto;
  height: ${pxToRem(140)};
  max-height: ${pxToRem(140)};
  padding: ${pxToRem(16)};
  background-color: var(--color__player);
  & img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  @media ${mq(sizes.tablet)} {
    min-width: ${pxToRem(116)};
    width: ${pxToRem(116)};
    max-width: ${pxToRem(116)};
    height: auto;
    min-height: ${pxToRem(116)};
    max-height: none;
  }
`
export const Infos = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(32)};
  overflow: hidden;
  &:not(:first-child) {
    border-block-start: 1px solid rgba(0, 0, 0, 0.5);
  }
  @media ${mq(sizes.tablet)} {
    &:not(:first-child) {
      border-block-start: unset;
      border-inline-start: 1px solid rgba(0, 0, 0, 0.5);
    }
  }
`
export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.d1440_h3}
  text-wrap: balance;
`
export const Subtitle = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
export const _AudioPlayer = styled(AudioPlayer)`
  padding: ${pxToRem(16)};
  &:not(:first-child) {
    border-block-start: 1px solid rgba(0, 0, 0, 0.5);
  }
  & button {
    background: unset;
  }
  .rhap_button-clear {
    display: flex;
    align-items: center;
  }
  & .rhap_main {
  }
  & .rhap_controls-section {
  }
  & .rhap_main-controls {
    display: flex;
    align-items: center;
  }
  &.rhap_play-status--playing .rhap_play-pause-button {
  }
  & .rhap_additional-controls {
  }
  & .rhap_progress-section {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  & .rhap_progress-container {
    flex: 1 1 auto;
    position: relative;
    transform: translateY(-1px);
  }
  & .rhap_progress-bar {
    position: relative;
    height: var(--height__progress);
    &::after {
      // to fake the border
      content: '';
      position: absolute;
      inset: 0;
      background: white;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
  & .rhap_progress-indicator {
    display: none;
  }
  & .rhap_progress-filled {
    position: absolute;
    inset: 0 auto auto 0;
    z-index: 4;
    height: var(--height__progress);
    transition: 0.1s width linear;
    transform: translate3d(0);
    will-change: width;
    background: var(--color__player);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  & .rhap_progress-container[aria-valuenow='0'] .rhap_progress-filled {
    opacity: 0;
  }
  & .rhap_download-progress {
    // hidden for now
    display: none;
    position: absolute;
    inset: 0 auto auto 0;
    z-index: 2;
    height: var(--height__progress);
    background: rgba(0, 0, 0, 0.05);
  }
  & .rhap_current-time {
  }
  & .rhap_total-time {
  }
  & .rhap_time {
    ${({ theme }) => theme.textStyles.d1440_body};
  }
  & .rhap_volume-controls {
  }
  & .rhap_volume-button {
    display: flex;
    align-items: center;
  }
  & .rhap_volume-container {
    display: flex;
    align-items: center;
    flex: 0 1 auto;
    gap: ${pxToRem(8)};
    user-select: none;
    -webkit-user-select: none;
  }
  & .rhap_volume-bar-area {
    // hidden on mobile
    display: none;
    align-items: center;
    width: 100%;
    height: ${pxToRem(10)};
    cursor: pointer;
    &:focus:not(:focus-visible) {
      outline: 0;
    }
  }
  & .rhap_volume-bar {
    position: relative;
    width: 100%;
    height: ${pxToRem(10)};
    &::after {
      content: '';
      position: absolute;
      inset-inline: 0;
      top: 50%;
      height: ${pxToRem(2)};
      translate: 0 -50%;
      background: rgba(0, 0, 0, 0.2);
    }
  }
  & .rhap_volume-indicator {
    box-sizing: border-box;
    position: absolute;
    width: ${pxToRem(3)};
    height: 100%;
    inset-block-start: 0;
    background: ${({ theme }) => theme.colors.black};
    cursor: pointer;
  }
  & .rhap_volume-filled {
    position: absolute;
    inset-inline-start: 0;
    top: 50%;
    height: ${pxToRem(4)};
    translate: 0 -50%;
    background: ${({ theme }) => theme.colors.black};
  }
  @media ${mq(sizes.tablet)} {
    & .rhap_volume-container {
      flex: 0 1 ${pxToRem(80)};
    }
    & .rhap_volume-bar-area {
      display: flex;
    }
  }
`
export const Button = styled.button`
  display: flex;
  align-items: center;
`
export const _Icon = styled(Icon)`
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
export const BigIcon = styled(_Icon)`
  width: ${pxToRem(40)};
`
export enum SpacerVariant {
  xsmall,
  small,
  medium,
  large,
}
export const Spacer = styled.span<{ $variant?: SpacerVariant }>`
  flex: 0 0 auto;
  width: ${({ $variant }) =>
    $variant === SpacerVariant.xsmall
      ? pxToRem(4)
      : $variant === SpacerVariant.small
        ? pxToRem(8)
        : $variant === SpacerVariant.medium
          ? pxToRem(16)
          : pxToRem(24)};
`
export const TimeSeparator = styled.span`
  margin-inline: ${pxToRem(4)};
`
// embed player
export const Embed = styled.div``
// transcript
export const _Transcript = styled(Transcript)``
